// Panelin standart yüzeyi: beyaz, ince kenar, yumuşak gölge.
// baslik/aksiyon verilirse başlık şeridi çizilir.
export default function Card({ baslik, altBaslik, aksiyon, children, padding = true, className = '' }) {
  return (
    <div className={`bg-white border border-slate-200/80 rounded-xl shadow-card overflow-hidden ${className}`}>
      {(baslik || aksiyon) && (
        <div className="flex items-center justify-between gap-3 px-5 py-3.5 border-b border-slate-100">
          <div className="min-w-0">
            {baslik && <h2 className="text-sm font-semibold text-slate-800 truncate">{baslik}</h2>}
            {altBaslik && <p className="text-xs text-slate-400 mt-0.5 truncate">{altBaslik}</p>}
          </div>
          {aksiyon && <div className="flex-shrink-0">{aksiyon}</div>}
        </div>
      )}
      <div className={padding ? 'p-5' : ''}>{children}</div>
    </div>
  );
}
